import { Data, UPSERT } from '@dimandzhi/graphql';
import _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export const UpsertResp = (action: UPSERT, ModelName: string) => map((data: Data) => {
  const result = data.upsertResp(action, ModelName);
  if (result === undefined) {
    throw new Error(`result is undefined`);
  }
  return result;
});

export const insertOp = (bo: BehaviorSubject<any[]>, o: any) => map(IDs => {
  if (!_.isArrayLike(IDs)) {
    throw new Error(`IDs is not an array: ${typeof IDs} ${IDs}`);
  }
  const id = _.head(IDs);
  if (!_.isNumber(id)) {
    throw new Error(`id is not a number: ${typeof id} ${id}`);
  }
  o.id = id;
  bo.next(bo.value.concat(o));
  return id;
});
